module.exports = __webpack_public_path__ + "img/produkte-active.73ff1806.svg";